import styled, { css } from 'styled-components'
import { font } from '../../styles/vars/font.style'
import { colors } from '../../styles/vars/colors.style'
import { clamp } from '../../styles/utils/conversion.style'
import { easings } from '../../styles/vars/easings.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'

export const ButtonMain = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: ${font.primary.family};
  ${clamp('font-size', 16, 22)}
  text-align: center;
  text-decoration: none;
  border: none;

  &[disabled] {
    opacity: 0.5;
    cursor: default;
    color: ${colors.light};
    background-color: ${colors.dark};
    border-color: ${colors.grey};
  }

  ${({ variant }) => {
    if (variant === 'default') {
      return ButtonDefault
    }

    if (variant === 'underline') {
      return ButtonUnderline
    }

    if (variant === 'outline') {
      return ButtonOutline
    }

    if (variant === 'fill') {
      return ButtonFill
    }
  }}
`

const ButtonDefault = css`
  color: ${props => props.color};
  border: none;
  background-color: transparent;
  transition-property: background-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ${easings.inOut.default};
`

const ButtonUnderline = css`
  padding-bottom: 0.3rem;
  color: ${props => props.color};
  background-color: transparent;
  border-bottom: 0.1rem solid ${props => props.color};
  transition-property: background-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ${easings.inOut.default};
`

const ButtonOutline = css`
  ${clamp('padding-top', 10, 15, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-right', 18, 32, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-bottom', 10, 15, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-left', 18, 32, breakpoints.mobile, breakpoints.contained)}
  color: ${props => props.color};
  background-color: transparent;
  border: 0.1rem solid ${props => props.color};
  border-radius: 2.5em;
  transition-property: background-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ${easings.inOut.default};
`

const ButtonFill = css`
  ${clamp('padding-top', 10, 15, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-right', 18, 32, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-bottom', 10, 15, breakpoints.mobile, breakpoints.contained)}
  ${clamp('padding-left', 18, 32, breakpoints.mobile, breakpoints.contained)}
  color: ${colors.dark};
  background-color: ${props => props.color};
  border: 0.1rem solid ${props => props.color};
  border-radius: 2.5em;
  transition-property: background-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ${easings.inOut.default};
`

export const ButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const ButtonMask = styled.span`
  overflow: hidden;
  position: relative;
  display: block;
`

export const ButtonMaskChild = styled.span`
  display: block;
  will-change: transform;

  * {
    display: block;
  }

  &:nth-child(1) {
    transition: transform ${easings.out.quart}, opacity ${easings.out.quart};
    transition-duration: 0.4s;
    transition-delay: 0.25s;
  }

  &:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    transform: translateY(100%);
    opacity: 0;
    transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
    transition-duration: 0.4s;
  }

  a:hover &,
  button:hover & {
    &:nth-child(1) {
      transform: translateY(-100%);
      opacity: 0;
      transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
      transition-duration: 0.4s;
    }

    &:nth-child(2) {
      transform: translateY(0);
      opacity: 1;
      transition: transform ${easings.out.quart}, opacity ${easings.out.quart};
      transition-duration: 0.4s;
      transition-delay: 0.25s;
    }
  }
`

export const ButtonIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  margin-left: ${props => (props.right ? '0.5em' : undefined)};
  margin-right: ${props => (props.left ? '0.5em' : undefined)};

  svg {
    width: 100%;
  }
`
